import { defa } from 'defa-object';
import Model    from 'scripts/poppet/model';

const apiHost = defa.vars.apiHost;
const api     = {
	technical: apiHost + '/units/%s/technical',
};

/**
 * defa.models.UnitTechnical
 * The DEFA model for unit tech information.
 * @version 1.2.0
 */
const UnitTechnical = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	url: function() {
		return api.technical.replace('%s', this.get('id'));
	},
	
	defaults: {
		iccid    : !1,
		activeSim: !1,
		ipAddress: !1,
		isChipSim: !1,
	},
} );

export default UnitTechnical;